// The wizard edits meals as { type, format } rows; the API stores them as text ("Lunch: Full meal").
const SEPARATOR = ": ";

export const mealsToApi = (meals = []) =>
  (Array.isArray(meals) ? meals : [])
    .map((meal) => {
      if (typeof meal === "string") return meal.trim();
      const type = (meal?.type || "").trim();
      const format = (meal?.format || "").trim();
      return type && format ? `${type}${SEPARATOR}${format}` : type || format;
    })
    .filter(Boolean);

export const mealsFromApi = (values = []) =>
  (Array.isArray(values) ? values : [])
    .map((value) => {
      if (value && typeof value === "object") return { type: value.type || "", format: value.format || "" };
      const text = String(value || "").trim();
      if (!text) return null;
      const at = text.indexOf(SEPARATOR);
      return at < 0
        ? { type: text, format: "" }
        : { type: text.slice(0, at).trim(), format: text.slice(at + SEPARATOR.length).trim() };
    })
    .filter(Boolean);
